export const adminDashboardEn = {
  // Navigation
  greeting: 'Hello',
  adminDashboard: 'Admin Dashboard',
  home: 'Home',
  dashboard: 'Dashboard',
  students: 'Students',
  teachers: 'Teachers',
  parents: 'Parents',
  grades: 'Grades',
  communication: 'Communication',
  communicationTitle: 'Messages & Communication',
  messages: 'Messages',
  emails: 'Emails',
  admins: 'Admins',
  statistics: 'Statistics',
  financialManagement: 'Financial Management',
  expenses: 'Income and Expenses',
  income: 'Income',
  expense: 'Expense',
  incomeTotal: 'Total Income',
  expenseTotal: 'Total Expenses',
  difference: 'Difference (Income - Expenses)',
  addFinancialRecord: 'Add Income or Expense',
  studentFees: 'Student Fees',
  teacherSalaries: 'Teacher Salaries',
  
  // Monthly contributions
  academicYear: 'Academic Year',
  category: 'Category',
  type: 'Type',
  totalAmount: 'Total Amount',
  annualEnrollment: 'Annual Enrollment',
  status: 'Status',
  notes: 'Notes',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  paid: 'Paid',
  unpaid: 'Unpaid',
  partial: 'Partial',
  allStudents: 'All Students',
  allParents: 'All Parents',
  allTeachers: 'All Teachers',
  total: 'Total',
  actions: 'Actions',
  confirmDelete: 'Are you sure you want to delete?',
  deleteSuccess: 'Deleted successfully',
  deleteError: 'Error deleting',
  
  // Common actions
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  update: 'Update',
  save: 'Save',
  cancel: 'Cancel',
  search: 'Search',
  filter: 'Filter',
  refresh: 'Refresh',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  confirm: 'Confirm',
  close: 'Close',
  
  // Status
  active: 'Active',
  inactive: 'Inactive',
  
  // Student management
  addStudent: 'Add Student',
  editStudent: 'Edit Student',
  deleteStudent: 'Delete Student',
  studentName: 'Student Name',
  studentPhone: 'Phone',
  studentIdNumber: 'ID Number',
  studentAddress: 'Address',
  studentLevel: 'Level',
  studentHalqa: 'Circle',
  studentNotes: 'Notes',
  studentParent: 'Parent',
  studentTeacher: 'Teacher',
  selectParent: 'Select Parent',
  selectTeacher: 'Select Teacher',
  studentAddedSuccess: 'Student added successfully',
  studentUpdatedSuccess: 'Student updated successfully',
  studentDeletedSuccess: 'Student deleted successfully',
  studentAddError: 'Error adding student',
  studentUpdateError: 'Error updating student',
  studentDeleteError: 'Error deleting student',
  confirmDeleteStudent: 'Are you sure you want to delete this student?',
  
  // Teacher management
  inscriptionRequests: 'Registration Requests',
  contactMessages: 'External Communication',
  allStatuses: 'All statuses',
  allTypes: 'All types',
  allSchoolYears: 'All school years',
  writeReply: 'Your reply...',
  archive: 'Archive',
  reply: 'Reply',
  send: 'Send',
  approved: 'Approved',
  rejected: 'Rejected',
  reviewed: 'Under Review',
  registered: 'Registered',
  pending: 'Pending',
  parent: 'Parent',
  teacher: 'Teacher',
  statusNew: 'New',
  statusRead: 'Read',
  statusReplied: 'Replied',
  statusArchived: 'Archived',
  registerParent: 'Register Parent',
  registerChildren: 'Register children',
  viewParent: 'View Parent Profile',
  requests: 'requests',
  details: 'Details',
  linkedAccount: 'Linked account',
  children: 'Children',
  child: 'child',
  reviewerNotes: 'Reviewer notes',
  by: 'by',
  notRegistered: 'Not registered',
  reEnroll: 'Re-enroll',
  studentsParents: 'Students & Parents',
  administration: 'Administration',
  manageTeachers: 'Manage Teachers',
  quranTracking: 'Memorization Tracking',
  studentProgress: 'Student Progress',
  adminsList: 'Management',
  addTeacher: 'Add Teacher',
  editTeacher: 'Edit Teacher',
  deleteTeacher: 'Delete Teacher',
  teacherName: 'Teacher Name',
  teacherUsername: 'Username',
  teacherPassword: 'Password',
  teacherEmail: 'Email',
  teacherPhone: 'Phone',
  teacherSpecialization: 'Specialization',
  teacherExperience: 'Years of Experience',
  teacherHireDate: 'Hire Date',
  teacherSalary: 'Salary',
  teacherAssignedHalqas: 'Assigned Circles',
  teacherNotes: 'Notes',
  teacherAddedSuccess: 'Teacher added successfully',
  teacherUpdatedSuccess: 'Teacher updated successfully',
  teacherDeletedSuccess: 'Teacher deleted successfully',
  teacherAddError: 'Error adding teacher',
  teacherUpdateError: 'Error updating teacher',
  teacherDeleteError: 'Error deleting teacher',
  confirmDeleteTeacher: 'Are you sure you want to delete this teacher?',
  
  // Parent management
  addParent: 'Add Parent',
  editParent: 'Edit Parent',
  deleteParent: 'Delete Parent',
  parentName: 'Parent Name',
  parentUsername: 'Username',
  parentEmail: 'Email',
  parentPhone: 'Phone',
  parentNotes: 'Notes',
  parentAddedSuccess: 'Parent added successfully',
  parentUpdatedSuccess: 'Parent updated successfully',
  parentDeletedSuccess: 'Parent deleted successfully',
  parentAddError: 'Error adding parent',
  parentUpdateError: 'Error updating parent',
  parentDeleteError: 'Error deleting parent',
  confirmDeleteParent: 'Are you sure you want to delete this parent?',
  
  // Admin management
  addAdmin: 'Add Admin',
  editAdmin: 'Edit Admin',
  deleteAdmin: 'Delete Admin',
  adminName: 'Admin Name',
  adminUsername: 'Username',
  adminPassword: 'Password',
  adminPasswordConfirm: 'Confirm Password',
  adminEmail: 'Email',
  adminPhone: 'Phone',
  adminPermissions: 'Permissions',
  adminNotes: 'Notes',
  adminAddedSuccess: 'Admin added successfully',
  adminUpdatedSuccess: 'Admin updated successfully',
  adminDeletedSuccess: 'Admin deleted successfully',
  adminAddError: 'Error adding admin',
  adminUpdateError: 'Error updating admin',
  adminDeleteError: 'Error deleting admin',
  confirmDeleteAdmin: 'Are you sure you want to delete this admin?',
  
  // Grade management
  addGrade: 'Add Grade',
  editGrade: 'Edit Grade',
  deleteGrade: 'Delete Grade',
  gradeStudent: 'Student',
  gradeSubject: 'Subject',
  gradeValue: 'Grade',
  gradeDate: 'Date',
  gradeComment: 'Comment',
  student: 'Student',
  studentLabel: 'Student(s)',
  subject: 'Subject',
  grade: 'Grade',
  date: 'Date',
  comment: 'Comment',
  selectStudent: 'Select Student',
  selectSubject: 'Select Subject',
  gradeAddedSuccess: 'Grade added successfully',
  gradeDeletedSuccess: 'Grade deleted successfully',
  gradeAddError: 'Error adding grade',
  gradeDeleteError: 'Error deleting grade',
  confirmDeleteGrade: 'Are you sure you want to delete this grade?',
  
  // Communication
  sendMessage: 'Send Message',
  sentMessages: 'Sent Messages',
  receivedMessages: 'Received Messages',
  emailsSending: 'Emails Sent',
  emailsReceiving: 'Emails Received',
  messageRecipient: 'Recipient',
  messageSubject: 'Message Subject',
  messageContent: 'Message Content',
  from: 'From',
  messagePriority: 'Priority',
  messageType: 'Message Type',
  messageSentSuccess: 'Message sent successfully',
  messageSendError: 'Error sending message',
  
  // Statistics
  totalStudents: 'Total Students',
  totalTeachers: 'Total Teachers',
  totalParents: 'Total Parents',
  averageGrade: 'Average Grade',
  unreadMessages: 'Unread Messages',
  
  // Form validation
  required: 'Required',
  invalidFormat: 'Invalid format',
  password: 'Password',
  passwordMismatch: 'Passwords do not match',
  unknownError: 'Unknown error',
  
  // Placeholders
  notSpecified: 'Not specified',
  noData: 'No data',
  selectOption: 'Select option',
  
  // Levels
  levelKindergarten: 'Kindergarten',
  level1: 'First',
  level2: 'Second',
  level3: 'Third',
  level4: 'Fourth',
  level5: 'Fifth',
  level6: 'Sixth',
  levelMiddle: 'Middle School',
  levelSecondary: 'Secondary School',
  
  // Halqas
  halqaMemorizationBook: 'Memorization Circle with Book',
  halqaMemorizationListening: 'Memorization Circle by Listening',
  
  // Back to home
  backToHome: 'Back to Home Page',
  logout: 'Logout',
  
  // Placeholders
  enterStudentName: 'Enter student name',
  enterPhone: 'Enter phone number',
  enterIdNumber: 'Enter ID number',
  enterAddress: 'Enter address',
  enterNotes: 'Enter any additional notes',
  enterGrade: 'Enter grade',
  enterMessageSubject: 'Enter message subject',
  enterMessageContent: 'Enter message content',
  enterTeacherFullName: 'Enter teacher full name',
  enterAdminFullName: 'Enter admin full name',
  enterEmail: 'Enter email address',
  confirmPassword: 'Confirm password',
  newPasswordOptional: 'New password (optional)',
  teacherNotesOptional: 'Notes about teacher (optional)',
  phoneFormat: '01xxxxxxxxx',

  // Quran Tracking
  quranTrackingTitle: 'Quran Memorization Tracking',
  addNewRecord: 'Add New Record',
  noStudents: 'No students',
  noStudentsFilter: 'No students match the filter',
  previousSessions: 'Previous Sessions',
  noRecords: 'No records available',
  editQuranRecord: 'Edit Quran Record',
  addQuranRecord: 'Add Quran Record',
  hide: 'Hide',
  show: 'Show',

  // Section Paramètres
  parameters: 'Parameters',
  parametersSection: 'Parameter Management',
  parameterName: 'Parameter Name',
  parameterValue: 'Value',
  parameterDescription: 'Description',
  addParameter: 'Add Parameter',
  editParameter: 'Edit Parameter',
  deleteParameter: 'Delete Parameter',
  parameterNamePlaceholder: 'Example: targetRepeatNewHifzCount',
  parameterValuePlaceholder: 'Enter value',
  parameterDescriptionPlaceholder: 'Enter description (optional)',
  parameterNameNote: 'Name must be in technical English format (e.g., targetRepeatNewHifzCount)',
  parameterCreated: 'Parameter created successfully',
  parameterUpdated: 'Parameter updated successfully',
  parameterDeleted: 'Parameter deleted successfully',
  confirmDeleteParameter: 'Are you sure you want to delete this parameter?',
  parameterNameRequired: 'Parameter name is required',
  parameterValueRequired: 'Parameter value is required',
  parameterAlreadyExists: 'A parameter with this name already exists',
  noParameters: 'No parameters',
  schoolYearSystemTitle: 'School year (system)',
  schoolYearSelectLabel: 'School year',
  schoolYearCalendarHint: 'Default: 1 Sep → 31 Aug (editable when creating)',
  schoolYearStartDate: 'Start',
  schoolYearEndDate: 'End',
  schoolYearClose: 'Close current year',
  schoolYearCloseTitle: 'Close school year',
  schoolYearCloseHelp: 'The current year becomes read-only. Choose the year to activate.',
  schoolYearActivate: 'Activate year',
  schoolYearConfirmClose: 'Close and activate',
  schoolYearClosing: 'Closing…',
  schoolYearCloseNeedNew:
    'Create the new school year first (« New year »), then close the current one.',
  schoolYearNew: 'Create a year',
  schoolYearCreate: 'Create',
  schoolYearCancel: 'Cancel',
  schoolYearCreating: 'Creating…',
  schoolYearCloseError: 'Error closing school year',
  current: 'current',
  closed: 'closed',
  parametersGeneralSection: 'Other application parameters',
  createdDate: 'Created Date',
  updatedDate: 'Last Updated',

  // Dashboard stats
  refreshing: 'Refreshing…',
  refreshDashboard: 'Reload dashboard data',
  lastRefresh: 'Updated at',
  statTotalStudents: 'Total Students',
  statPresentToday: 'Present Today',
  noSessionsToday: 'No session',
  kpiPerimeterMismatch: 'Scope being synchronized',
  statAbsentToday: 'Absent Today',
  statPendingRequests: 'Pending Requests',
  statNewMessages: 'New Messages',

  // Dashboard tabs
  tabActivities: 'Recent Activities',
  tabLastSession: 'Last Session Attendance',
  tabAttendanceByDate: 'Attendance by Date',

  // Activity labels
  actMessageFrom: 'Message from',
  actUnknownSender: 'Unknown sender',
  actNoContent: 'Content not available',
  actUnknownDate: 'Unknown date',
  actNoMessages: 'No recent messages',
  actNoMessagesDesc: 'No messages found in the system',
  actPendingRegistration: 'registration request(s) pending review',
  actClickDetails: 'Click for details',
  actNewContactMessage: 'new contact message(s)',
  actClickReply: 'Click to reply',
  actTotalStudents: 'Total registered students',
  actStudentInSystem: 'student(s) registered in the system',
  actActiveTeachers: 'Active Teachers',
  actTeacherInSystem: 'active teacher(s) in the system',
  actNow: 'Now',
  actPresent: 'Present',
  actAbsent: 'Absent',
  actSaving: 'Saving...',

  // Generic UI
  all: 'All',
  male: 'Male',
  female: 'Female',
  gender: 'Gender',
  phone: 'Phone',
  permissions: 'Permissions',
  to: 'To',
  username: 'Username',
  adminTitle: 'Admin',
  administrationBoard: 'Administration',
  applicantInfo: 'Applicant Information',
  teacherInfoLabel: 'Teacher Information',
  memorizedHizb: 'Memorized Hizb',
  presentFilter: 'Present',
  absentFilter: 'Absent',
  allTeachersOption: 'All Teachers',

  // Empty states
  noSentMessages: 'No sent messages',
  noReceivedMessages: 'No received messages',
  noAdminsRegistered: 'No admins registered in the system',
  noFinancialRecords: 'No financial records found',
  noContributions: 'No contributions recorded',
  noSalaries: 'No salaries recorded',
  noAccessPermission: 'You do not have access to this section',
  totalAbsences: 'Total Absences',
  noTeachersRegistered: 'No teachers registered yet',
  inactiveFilterHint: 'When checked, inactive teachers are also shown',
  noActiveTeachers: 'No active teachers. Check “Inactive” to show them',
  addTestScore: 'Add Test Score',
  gradeOutOf20: 'Grade (/20)',
  noTestScores: 'No test scores recorded',
  addTestScoreHint: 'Click "Add Test Score" to add a new score',
  noSubjectsAvailable: 'No subjects available',
  // Students / Parents UI
  infoSectionTitle: '📋 Information',
  filters: '🔍 Filters',
  selectColumns: 'Select Columns',
  selectAll: 'Select All',
  resetFilters: 'Reset Filters',
  viewTable: 'Table View',
  viewCards: 'Card View',
  noFilterResults: 'No results matching the filters',
  tryChangingFilters: 'Try changing the filter criteria',
  noStudentsRegistered: 'No students registered in the system',
  addStudentHint: 'Click "Add Student" to add a new one',
  noParentsRegistered: 'No parents registered yet',
  noFilterResultsParents: 'No results for this search',
  addParentHint: 'Click "Add Parent" to add a new one',
  addNewStudent: 'Add New Student',
  editStudentTitle: 'Edit Student Data',
  addNewParent: 'Add New Parent',
  editParentTitle: 'Edit Parent Data',
  noChildrenRegistered: 'No children registered',
  childrenSection: '🎓 Children',
  personalInfoSection: '📋 Personal Information',
  saveChanges: 'Save Changes',
  selectLevel: 'Select Level',
  selectHalqa: 'Select Halqa',
  newPassword: 'New Password',
  optional: '(optional)',
  sendCredentials: 'Send credentials via:',
  saveStudent: 'Save Student',
  saveParent: 'Add Parent',
  errorAddingStudent: 'Error adding student',
  errorEditingStudent: 'Error editing student',
  errorAddingParent: 'Error adding parent',
  errorEditingParent: 'Error editing parent',
  noParentsAvailable: 'No parents registered in the system',
  suspended: 'Suspended',
  withdrawn: 'Withdrawn',
  address: 'Address',
  email: 'Email',
  averageTestScores: 'Average Test Scores',
  memorizationStatistics: 'Memorization Statistics',
  memorizationLevelAdvanced: 'Advanced',
  memorizationLevelIntermediate: 'Intermediate',
  memorizationLevelBeginner: 'Beginner',
  noStudentsMatchFilter: 'No students match the selected filter',

  // Quran tracking - previous sessions table columns
  quranTableDate: 'Date',
  quranTableNewHifz: 'New Hifz',
  quranTableOldMurajah: 'Old Murājaʿah',
  quranTableNewMurajah: 'New Murājaʿah',
  quranTableEvalNewHifz: 'Eval. Hifz',
  quranTableEvalOldMurajah: 'Eval. Old Murājaʿah',
  quranTableEvalNewMurajah: 'Eval. New Murājaʿah',
  quranTableNote: 'Note',
  quranTableHizb: 'No. Hizb',
  quranHizbLabel: 'hizb memorized',
  quranProgressLabel: 'Progress',
  quranProgressPercent: '% of Quran',
};

